<aside id="invoice-details-sidebar" class="sidebar-shell h-full flex flex-col" [attr.aria-label]="'invoice_extract.details.title' | translate">
  <header class="sidebar-header px-5 py-5">
    <div class="flex items-start justify-between gap-4 mb-4">
      <div id="invoice-details-sidebar-header-icon" class="header-icon-box">
        <mat-icon>receipt_long</mat-icon>
      </div>

      <button
        id="invoice-details-sidebar-close-button"
        type="button"
        class="close-button"
        [attr.aria-label]="'common.close' | translate"
        (click)="onClose()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <h3 id="invoice-details-sidebar-title" class="sidebar-title">{{ 'invoice_extract.details.title' | translate }}</h3>

    @if (data(); as detail) {
      <p id="invoice-details-sidebar-invoice-number" class="sidebar-subtitle">
        {{ 'invoice_extract.details.invoice_number' | translate: { number: detail.numero } }}
      </p>
    }
  </header>

  @if (data(); as detail) {
    <div class="status-row px-5 py-3">
      <span [class]="statusBadgeClass()">{{ detail.status }}</span>
    </div>
  }

  <div class="flex-1 overflow-y-auto px-5 py-4 relative">
    <app-inline-loading [loadingKey]="detailsLoadingKey" />

    @if (data(); as detail) {
      <section class="section-card">
        <div class="section-header flex items-center gap-2">
          <span class="section-icon-box"><mat-icon>info</mat-icon></span>
          <strong>{{ 'invoice_extract.details.general_info' | translate }}</strong>
        </div>

        <div class="info-grid grid grid-cols-1 sm:grid-cols-2 gap-4">
          @for (item of infoItems(); track trackByLabel($index, item)) {
            <div class="info-item">
              <p class="info-label">{{ item.labelKey | translate }}</p>
              <p class="info-value">{{ item.value }}</p>
            </div>
          }
        </div>
      </section>
    }
  </div>
</aside>
